<!-- my-component.vue -->
<template>
<!-- Button trigger modal -->

<div class="landin-1-api">
    <div class="row" style="position:absolute;z-index:6;width:100vw;margin-left:0px;">
        <div class="hidden-xs col-md-1"></div>
        <div class="col-12 col-md-7 text-landing-1">
            <h1 class="title-landing">Privacy page</h1>
        </div>
        <div class="co-12 col-md-4" style="text-align:center;margin:0;">
           
        </div>
    </div>
    <div  style="position:absolute;bottom:0;width:100%;">
        
    </div>
    
</div>
</template>

<script scoped>

export default {
data() {
  return {
    msg: "Hello World!",
    isShowMyModal: false,
    waves: require('./assets/img/app/waves.svg'),
    mobile_app: require('./assets/img/app/mobile-app.svg')
  }
}
  }
</script>
<style scoped>
/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}
.landin-1-api{
  height:920px;
  position:relative;
/* blue: */
background-image: linear-gradient(-180deg, #32AEDE 0%, #3498DB 100%);
  padding-top:100px;
  width:100%;
}
}

/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}
.text-landing-1{
    padding-top:100px;
}
.landin-1-api{
  height:780px;
  position:relative;
/* blue: */
background-image: linear-gradient(-180deg, #32AEDE 0%, #3498DB 100%);
  padding-top:100px;
  width:100%;
}
}


.title-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
font-weight:normal;
}


.landin-2-website{
  height:750px;
 background-color:white;
  width:100%;
  padding-top:800px;
}


</style>


// WEBPACK FOOTER //
// src/privacy.vue